import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../App";

export default function LoginAdmin() {
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await api.loginAdmin(usuario.trim(), password);
      login(data.token, { ...data.usuario, rol: "admin" });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page-center">
      <div style={{ width: "100%", maxWidth: 400 }}>
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <img src="/logo-azul.png" alt="FRICSA" style={{ height: 100, marginBottom: 4 }} />
          <div style={{ color: "var(--gray)", fontSize: 14 }}>Administración de RRHH</div>
        </div>

        <div className="card">
          <h2 style={{ marginBottom: 24, fontSize: 18, color: "var(--navy)" }}>
            Acceso administrador
          </h2>
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            <div className="input-group">
              <label>Usuario</label>
              <input type="text" value={usuario} onChange={e => setUsuario(e.target.value)} required autoFocus />
            </div>
            <div className="input-group">
              <label>Contraseña</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            {error && <div className="alert alert-error">{error}</div>}
            <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
              {loading ? "Ingresando..." : "Ingresar"}
            </button>
          </form>
        </div>

        <div style={{ textAlign: "center", marginTop: 20, fontSize: 13 }}>
          <Link to="/" style={{ color: "var(--gray)" }}>← Volver al portal</Link>
        </div>
      </div>
    </div>
  );
}
